import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaSaldosDetalleMovimientosMovimiento', {
    template: template,
    controller: NominasNominaSaldosDetalleMovimientosMovimiento,
    bindings: {
      data: '<',
      onChange: '&',
      onDelete: '&',
    },
  })

function NominasNominaSaldosDetalleMovimientosMovimiento() {
  let $ctrl = this

  $ctrl.calcularCargo = calcularCargo
  $ctrl.calcularAbono = calcularAbono
  $ctrl.eliminar = eliminar

  function calcularCargo() {
    $ctrl.data.cargo.importe = redondear($ctrl.data.abono.importe * $ctrl.data.abono.tipo_cambio)

    actualizar()
  }

  function calcularAbono() {
    $ctrl.data.abono.importe = redondear($ctrl.data.cargo.importe * $ctrl.data.cargo.tipo_cambio)

    actualizar()
  }

  function actualizar() {
    $ctrl.onChange({$event: {data: $ctrl.data}})
  }

  function eliminar() {
    $ctrl.onDelete()
  }

  function redondear(numero) {
    return parseFloat(numero.toFixed(2))
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/saldos/detalle/movimientos/movimiento/component.js